import React, { useEffect, useState } from 'react'
import { Modal } from 'antd'

import CustomButton from '../CustomButton'
import { deleteUserGroup, getUserGroup } from '../../redux/actions/groupcampaignAction';


const DeleteGroupmodal = ({ visible, onClose,setNotificationmodal,deletegroup,selectedCheckboxes}) => {

const[,setBoxes]=useState([])

useEffect(() => {
  // Only update if selectedCheckboxes is a non-empty array
  if (Array.isArray(selectedCheckboxes) && selectedCheckboxes.length > 0) {
    setBoxes(selectedCheckboxes); // Set boxes to selectedCheckboxes if it's not empty
  } 
}, [selectedCheckboxes]);
  const cancel = () => {
    // setPlayerInfo({})
    onClose()
  }

const onsave=async()=>{

   onClose()


try {
if ((deletegroup?.length > 0) || (selectedCheckboxes?.length > 0)){
  const validusers = [
    ...(Array.isArray(selectedCheckboxes) ? selectedCheckboxes : [selectedCheckboxes]),  // Wrap in an array if it's not already an array
    ...(Array.isArray(deletegroup) ? deletegroup.filter(id => typeof id === 'string') : [])  // Filter deletegroup to include only strings
  ];    
    let payload={
      ids:validusers
    }
  const res= await deleteUserGroup(payload)
   if (res?.data){
    let organizationid = localStorage.getItem("organizationid");
    // let page = 1;
    let payload = { organizationid };

    await getUserGroup(payload);

   }
   cancel()

  }

} catch (error) {

  
}

 
}
  


  return (
    <Modal
      className='deletemodal'
      title=''
      open={visible}
      onCancel={onClose}
      centered
     footer={[
        
      
        
      ]}
      
    >

   
<h1>

  Delete Group?
</h1>



<p>
  Do you want to delete {selectedCheckboxes?.length > 1 ? `${selectedCheckboxes.length} Groups` : 'this Group'}?
</p>


<div className='btn'>

   <CustomButton onClick={onsave} text={'Yes'}/>


   <CustomButton onClick={cancel} text={'No'}/>
 
</div>
    </Modal>




  )
}

export default DeleteGroupmodal;
